import React, {PropTypes} from 'react';
import Button from '../../common/Button';
import ReactTooltip from 'react-tooltip';
import {Glyphicon} from 'react-bootstrap';
import {ESTABLISHMENT_STATUS, ESTABLISHMENT_SIZE, ESTABLISHMENT_TYPE} from '../../../constants/EstablishmentStatusEnumeration';

const EstablishmentHeader = ({
  establishment,
  submission,
  restoreEstablishment,
  showRemovePage,
  editEstablishment,
  requireSizeReclassification})=> {
  let zipcode = establishment.address.zip.length ==9
    ? establishment.address.zip.slice(0,5) + '-' + establishment.address.zip.slice(5)
    : establishment.address.zip;
  return (
    <div className="establishment-info-header">
      <div className="establishment-info-container col-sm-9">
        <div className="border-container ">
          <h2 className="col-xs-12 detail-title">
            <div className="pull-left">Establishment Details: </div>
            <b className="establishment-name col-xs-12 col-sm-8 row">
              {establishment.establishment_status==2 && <em> [Inactive] </em>}
              {establishment.establishment_name}
            </b>
          </h2>
          <div className="establishment-details col-sm-6 col-xs-12">
            <div><b>ID: </b> {establishment.id}
              <span className="tooltip-container">
                <Glyphicon glyph="info-sign" className = "span-tooltip"
                  data-tip data-for={"establishment-id"}/>
                <ReactTooltip id={"establishment-id"} place="right"
                  type="dark" effect="float" >
                  This is a system generated ID. Include this information if you contact the help desk about this establishment.
                </ReactTooltip>
              </span>
            </div>
            <div><b>EIN: </b>{establishment.ein && establishment.ein.ein}</div>
            <div><b>Company: </b> {establishment.company &&
              establishment.company.company_name} </div>
            <div><b>Address: </b>{establishment.address.street},</div>
            <div style={{paddingLeft:"60px"}}>{establishment.address.city}, {establishment.address.state}, {zipcode}</div>
          </div>
          <div className="establishment-details col-sm-6 col-xs-12">
            <div><b>NAICS:</b> {establishment.naics.naics_code}</div>
            <div><b>Size:</b> {ESTABLISHMENT_SIZE[establishment.size]}
              {requireSizeReclassification == true &&
                <span className="tooltip-container" onClick={editEstablishment}>
                  <Glyphicon glyph="warning-sign" className="establishment-size-alert"
                    data-tip data-for={"establishment-id"}/>
                  <ReactTooltip id={"establishment-id"} place="right"
                    type="dark" effect="float">
                    Establishment size reclassification required.
                  </ReactTooltip>
                </span>
              }
            </div>
            <div><b>Government:</b> {ESTABLISHMENT_TYPE[establishment.establishment_type]}</div>
            <div><b>300A Status:</b> {ESTABLISHMENT_STATUS[establishment.submission_status]}</div>
          </div>
          { !submission &&
            <div className="col-sm-12 establishment-buttons-container row">
              <Button
                value="Edit Details"
                disabled={establishment.establishment_status == 2}
                onClick={editEstablishment}/>
              { establishment.establishment_status == 2
              ?
                <Button
                  value="Reactivate"
                  disabled={false}
                  onClick={restoreEstablishment}/>
              :
                <Button
                  className="btn-cancel"
                  value="Remove"
                  disabled={false}
                  onClick={showRemovePage}/>
              }
            </div>
          }
        </div>
      </div>
    </div>
  );
};

EstablishmentHeader.propTypes = {
  establishment: PropTypes.object.isRequired,
  restoreEstablishment: PropTypes.func,
  showRemovePage: PropTypes.func,
  editEstablishment: PropTypes.func,
  submission: PropTypes.bool,
  requireSizeReclassification: PropTypes.bool
};

export default EstablishmentHeader;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/EstablishmentHeader.js
 **/